import React from "react";

const RangeSelector = ({ selectedRange, setRange, ranges }) => {
  const handleClick = (range) => {
    setRange(range);
  };
  return (
    <hgroup>
      {Object.keys(ranges).map((key) => {
        return (
          <button
            data-button-type={
              selectedRange.key === key ? "primary" : "secondary"
            }
            onClick={() => handleClick(ranges[key])}
            key={key}
          >
            {ranges[key].label}
          </button>
        );
      })}
    </hgroup>
  );
};

export default RangeSelector;
